jQuery(function ($) {
    /**
     * Hide/Show header search form
     */
    $("#main-nav button.search-icon").click(function (e) {
        e.preventDefault();

        const $search_form = $(this).siblings(".search-form");
        const open = $search_form.hasClass("slide-in");

        if (!open) {
            $search_form.addClass("slide-in");
            $search_form.attr("aria-hidden", "false");
            $search_form.find('[type="search"]').focus();
        } else {
            $search_form.removeClass("slide-in");
            $search_form.attr("aria-hidden", "true");
        }
    });

    /**
     * jQuery UI Accordion
     * https://api.jqueryui.com/accordion/
     */
    $(".accordion").each(function () {
        $(this).accordion({
            active: $(this).hasClass("closed") ? false : 0,
            collapsible: true,
            icons: {
                header: "fa fa-caret-right",
                activeHeader: "fa fa-caret-down",
            },
            heightStyle: "content",
        });
    });

    /**
     * jQuery UI Tabs
     * https://api.jqueryui.com/tabs/
     */
    $(".tabs").tabs();

    /**
     * lightSlider Carousel Slider
     * http://sachinchoolur.github.io/lightslider/
     */
    $(".lightSlider").lightSlider({
        item: 3,
        autoWidth: true,
        slideMargin: 0,

        prevHtml: '<i class="fa fa-angle-left"></i>',
        nextHtml: '<i class="fa fa-angle-right"></i>',

        keypress: true,

        responsive: [
            {
                breakpoint: 768,
                settings: {
                    item: 1,
                },
            },
        ],
    });
});
